import { Clock, ClipboardCheck, ClipboardList } from "lucide-react";

// Új státusz értékek (a régi "eredmény" mező helyett).
export const INSPECTION_STATUSES = [
  { value: "new", label: "Új bejegyzés", icon: ClipboardList, tone: "muted" },
  { value: "investigating", label: "Kivizsgálás alatt", icon: Clock, tone: "amber" },
  { value: "closed", label: "Lezárva", icon: ClipboardCheck, tone: "emerald" },
];

export const STATUS_TONES = {
  emerald:
    "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-400",
  amber:
    "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-400",
  red:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-400",
  muted: "border-border bg-muted text-muted-foreground",
};

export function inspectionStatusMeta(value) {
  return INSPECTION_STATUSES.find((r) => r.value === value) || INSPECTION_STATUSES[0];
}

// Büntetés
export const INSPECTION_PENALTIES = [
  { value: "had_penalty", label: "Volt büntetés", tone: "red" },
  { value: "no_penalty", label: "Nem volt büntetés", tone: "emerald" },
];

export function inspectionPenaltyMeta(value) {
  return INSPECTION_PENALTIES.find((p) => p.value === value) || null;
}

// Bejelentés alapján volt-e az ellenőrzés
export const INSPECTION_TRIGGERS = [
  { value: "yes", label: "Bejelentés alapján" },
  { value: "no", label: "Nem bejelentés alapján" },
];

export function inspectionTriggerLabel(value) {
  const t = INSPECTION_TRIGGERS.find((x) => x.value === value);
  return t ? t.label : null;
}

// ---------- Backwards compatibility ----------
// Korábbi ("result") -> új ("status") leképezés, hogy a régi tételek is jól
// rendereljenek, ha még nem migrálódtak.
const LEGACY_RESULT_TO_STATUS = {
  pending: "new",
  passed: "closed",
  warning: "investigating",
  failed: "closed",
};

export function getInspectionStatus(inspection) {
  if (!inspection) return "new";
  if (inspection.status) return inspection.status;
  return LEGACY_RESULT_TO_STATUS[inspection.result] || "new";
}

// Legacy exports kept temporarily for code paths not yet migrated.
export const INSPECTION_RESULTS = INSPECTION_STATUSES;
export const RESULT_TONES = STATUS_TONES;
export const inspectionResultMeta = inspectionStatusMeta;
